import * as React from "react";
import { Card } from "antd";

interface Props {}
export const TritonNoNodePool: React.FC<Props> = ({}) => {
  return (
    <div className="cpln-form-section cpln-ant-tab-content">
      <Card>
        <div className="text-lg font-semibold">No Node Pools</div>
      </Card>
    </div>
  );
};
